export const DATE_FORMAT = 'DD.MM.YYYY';
export const MONTH_FORMAT = 'MM.YYYY';
export const DATE_WITH_TIME_FORMAT = 'DD.MM.YYYY HH:mm';
